// @flow
import { PRODUCT_SETTINGS, RESET_PRODUCT_SETTINGS } from '../../../ActionsConst';

type NewSettings = {
  productTypeId?: string,
  start: number,
  isLoading: boolean,
  productSize?: string,
  productSort?: string,
  searchTerm?: string | Object,
  template?: string,
  hasMore?: boolean,
  total?: number,
};

export const productSettings = (newSettings: NewSettings) => ({
  type: PRODUCT_SETTINGS,
  newSettings,
});

export const resetProductSettings = () => ({
  type: RESET_PRODUCT_SETTINGS,
});
